import { ca } from '@cian/analytics';

import { IFullTipSchema, EType } from '../../../repositories/text-search/entities/tips/FullTipSchema';

interface IParameters {
  clickedTip: IFullTipSchema;
}

export function trackTipClick({ clickedTip }: IParameters) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'search_string',
    action: 'click_chips',
    label: clickedTip.text,
    page: {
      extra: {
        isAutoCompleteChips: clickedTip.type === EType.Ml,
      },
    },
  });
}
